import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { createDevice, deleteDevice, updateDevice } from './actions';

export interface DevicesState {
  isMutating: boolean;
}

export function createCreateDeviceReducer(builder: ActionReducerMapBuilder<DevicesState>) {
  builder
    .addCase(createDevice.pending, (state) => {
      state.isMutating = true;
    })
    .addCase(createDevice.fulfilled, (state) => {
      state.isMutating = false;
    })
    .addCase(createDevice.rejected, (state) => {
      state.isMutating = false;
    });
}

export function createUpdateDeviceReducer(builder: ActionReducerMapBuilder<DevicesState>) {
  builder
    .addCase(updateDevice.pending, (state) => {
      state.isMutating = true;
    })
    .addCase(updateDevice.fulfilled, (state) => {
      state.isMutating = false;
    })
    .addCase(updateDevice.rejected, (state) => {
      state.isMutating = false;
    });
}

export function createDeleteDeviceReducer(builder: ActionReducerMapBuilder<DevicesState>) {
  builder
    .addCase(deleteDevice.pending, (state) => {
      state.isMutating = true;
    })
    .addCase(deleteDevice.fulfilled, (state) => {
      state.isMutating = false;
    })
    .addCase(deleteDevice.rejected, (state) => {
      state.isMutating = false;
    });
}
